import { SET_UNDO_STATE_SYNC, SET_UNDO_TYPE } from '../mutation-types'

// Add as a value of Key-Value pairs the translation strings
export const undoTypes = {
  INTERVENTION_CREATION: 'intervention_creation_cancelled',
  INTERVENTION_DELETION: 'intervention_deleted',
  ADMIN_ALERT_EMAIL_DELETION: 'admin.alerts.email.deleted',
  ANNOUNCEMENT_DELETION: 'announcements.deleted',
  INTERVENTION_EDIT: 'intervention_edit_cancelled',
  EXEMPTION_CREATION: 'exemption_creation_cancelled',
  EXEMPTION_EDIT: 'exemption_edit_cancelled',
  SAVE_FILTER_CREATION: 'save_filter_done',
  SAVE_FILTER_DELETION: 'save_filter_deletion',
  CHART_DELETED: 'dashboard.chart.chart_deleted',
  DATA_SET_DELETED: 'admin.alerts.new.data_sets.data_set_deleted',
  ALERT_DELETED: 'admin.alerts.new.alert_deleted',
  EMAIL_TEMPLATE_DELETED: 'admin.alerts.new.email_templates.email_template_deleted'
}

const state = {
  state: false,
  type: undoTypes.INTERVENTION_CREATION
}

const mutations = {
  [SET_UNDO_STATE_SYNC] (state, value) {
    state.state = value
  },
  [SET_UNDO_TYPE] (state, type) {
    state.type = type
  }
}

const actions = {
  SET_UNDO_STATE_ASYNC ({commit}, value) {
    if (state.state && value) {
      commit(SET_UNDO_STATE_SYNC, false)
      setTimeout(() => {
        commit(SET_UNDO_STATE_SYNC, true)
      }, 300)
    } else {
      commit(SET_UNDO_STATE_SYNC, value)
    }
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/undo.js